import { render, staticRenderFns } from "./EquipsFrame.vue?vue&type=template&id=59a409f9&scoped=true&"
import script from "./EquipsFrame.vue?vue&type=script&lang=js&"
export * from "./EquipsFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a409f9",
  null
  
)

export default component.exports